import { render, staticRenderFns } from "./SolutionDetails.vue?vue&type=template&id=da7814f8&scoped=true"
import script from "./SolutionDetails.vue?vue&type=script&lang=js"
export * from "./SolutionDetails.vue?vue&type=script&lang=js"
import style0 from "./SolutionDetails.vue?vue&type=style&index=0&id=da7814f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7814f8",
  null
  
)

export default component.exports